import ConfirmModal from '@/components/Common/ConfirmModal';
import { Tag } from '@/apis/agency/taggings/types';
import { titleizeTagName } from './businessTags';

interface Props {
  open: boolean;
  tag: Tag | null;
  onClose: () => void;
  onConfirm: () => void;
}

export default function RemoveChurnSignalModal({ open, tag, onClose, onConfirm }: Props) {
  if (!tag) return null;

  const label = tag.label || titleizeTagName(tag.name);

  return (
    <ConfirmModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title='Are you sure?'
      description={`Removing '${label}' will delete this churn signal.`}
      cancelText='Cancel'
      confirmText='Yes Sure'
    />
  );
}
